import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-facility-management',
  templateUrl: './facility-management.component.html',
  styleUrls: ['./facility-management.component.scss']
})
export class FacilityManagementComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title  
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Facility Management');
  }

}
